module.exports = __webpack_public_path__ + "img/like.dd06613c.svg";